import { money } from './receipt-utils';

const DEFAULT_SHIPPING_FEE = 2;

interface ReceiptTotalsProps {
  totalQuantity: number;
  subtotal: number;
  discount?: number;
  tax?: number;
  shippingFee?: number;
  total: number;
  showPrices?: boolean;
}

export function ReceiptTotals({
  totalQuantity,
  subtotal,
  discount = 0,
  tax = 0,
  shippingFee = 2,
  total,
  showPrices = true,
}: ReceiptTotalsProps) {
  return (
    <div className="receipt-totals font-bold text-xs">
      <div className="px-4 py-2.5">
        <div className="space-y-1">
          <div className="flex justify-between items-center">
            <span className="font-bold">Total Quantity</span>
            <span className="font-bold pr-3">{totalQuantity}</span>
          </div>

          {showPrices && (
            <>
              {/* <TotalsRow label="Subtotal" value={money(subtotal)} />

              {discount > 0 && (
                <TotalsRow label="Discount" value={`- ${money(discount)}`} />
              )}

              {tax > 0 && (
                <TotalsRow label="Tax" value={money(tax)} />
              )}

              {shippingFee > 0 && (
                <TotalsRow label="Delivery Fee" value={money(shippingFee)} />
              )} */}

              <TotalsRow
                label="Total"
                value={money(total)}
                className="text-xl font-bold"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

interface TotalsRowProps {
  label: string;
  value: string;
  className?: string;
}

function TotalsRow({ label, value, className }: TotalsRowProps) {
  return (
    <div className={`flex justify-between items-center font-bold ${className ?? ''}`.trim()}>
      <span>{label}</span>  
      <span>{value}</span>
    </div>
  );
}
